<template>
<v-dialog
:value="show"
persistent
hide-overlay
>
	<v-card>
		<v-card-title class="headline">
			NRPL scripting
		</v-card-title>
		<v-container>
			<v-layout row wrap>
				<v-flex xs12>
					<v-alert
					:value="status.message"
					:type="status.type"
					icon="warning"
					>
					{{status.message}}
					</v-alert>
				</v-flex>
				<v-flex xs12>
					<v-layout row>
						<v-textarea id="script" label="NRPL script" v-model="script" rows=10>
						</v-textarea>
						<v-textarea id="stack" label="NRPL results" v-model="stack" readonly rows=10>
						</v-textarea>
					</v-layout>
				</v-flex>
			</v-layout>
		</v-container>
			<v-card-actions>
			
				<v-btn
				flat
				:icon="$vuetify.breakpoint.xsOnly"
				@click="dismiss">
					<v-icon :left="$vuetify.breakpoint.smAndUp" small>fa-times-circle</v-icon>
					<span class="hidden-xs-only">Close</span>
				</v-btn>
				
				<v-btn
				flat
				:icon="$vuetify.breakpoint.xsOnly"
				color="secondary"
				@click="clear"
				:disabled="!formValid">
					<v-icon :left="$vuetify.breakpoint.smAndUp" small>fa-broom</v-icon>
					<span class="hidden-xs-only">Clear</span>
				</v-btn>
				
				<v-spacer></v-spacer>
				
				<v-chip
				outline
				:color="filtered.length? 'blue' : 'blue lighten-3'">
					<v-avatar>
						<v-icon small>fa-database</v-icon>
					</v-avatar>
					{{filtered.length}} <span class="hidden-xs-only"> fixes</span>
				</v-chip>
				
				<v-spacer></v-spacer>
				
				<v-btn
				color="success"
				:icon="$vuetify.breakpoint.xsOnly"
				:outline="$vuetify.breakpoint.xsOnly && !formValid"
				@click="exec"
				:disabled="!formValid"
				accesskey="X">
					<v-icon :left="$vuetify.breakpoint.smAndUp" small>fa-play</v-icon>
					<span class="hidden-xs-only">Run</span>
				</v-btn>
				
				<v-btn
				color="primary"
				:icon="$vuetify.breakpoint.xsOnly"
				:outline="$vuetify.breakpoint.xsOnly && !formValid"
				@click="save"
				:disabled="!formValid"
				accesskey="S">
					<v-icon :left="$vuetify.breakpoint.smAndUp" small>fa-save</v-icon>
					<span class="hidden-xs-only">Save</span>
				</v-btn>
				
			</v-card-actions>
	</v-card>
</v-dialog>
</template>

<style lang="stylus" scoped>
>>>
	textarea
		font-size 9pt
		font-family mono
	#script
		color blue
		font-style bold
</style>

<script>
import Vuex from 'vuex'
import NRPL from 'nrpl';

export default {
	name: "FollowScripting",
	
	props: ["show"],

	data () {
		return {
			script: "",
			stack: "",
			filtered: [],
			status: {}
		};
	},
	
	computed: {
		fixes () {
			return Object.values(this.$store.state.tokenData.fixes)
			.reduce( (a, b) => [...a, ...b]);
		},
		
		filteredCount () {
			return this.filtered.length;
		},

		formValid () {
			return !!this.script;
		}
	},

	methods: {
		async dismiss () {
			this.$emit("hide");
		},
		
		clear () {
			this.status = {};
			this.script = "";
			this.stack = "";
			this.filtered = [];
		},
		
		async exec () {
			const nrpl = new NRPL(null, null, true);
			try {
				this.status = {};
				const result = await nrpl.exec(this.script, [...this.fixes]);
				this.stack = JSON.stringify(result, null, 4);
				this.filtered = JSON.parse(this.stack)
					.filter(item => item instanceof Object && item.token_id);
			} catch (err) {
				this.status = {
					type: "error",
					message: "Error evaluating expression"
				};
				console.error(err);
			}
		},
		
		save () {
			this.$store.commit('setFiltered', this.filtered);
			this.dismiss();
		}
	}

}
</script>
